import { render } from "./TaskActTemplate.vue?vue&type=template&id=2ab45326"
import script from "./TaskActTemplate.vue?vue&type=script&lang=js"
export * from "./TaskActTemplate.vue?vue&type=script&lang=js"

import "./TaskActTemplate.vue?vue&type=style&index=0&id=2ab45326&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__